import { useCallback, useEffect, useState } from 'react';
import { UserCreatedChallengeDialog } from './UserCreatedChallengeDialog';

export const useUserCreatedChallengeDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [challengeId, setChallengeId] = useState<string | undefined>(undefined);

  const openDialog = useCallback((id?: string) => {
    setChallengeId(id);
    setIsOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsOpen(false);
    setChallengeId(undefined);
  }, []);

  useEffect(() => {
    if (!window.COMPONENTS) {
      return;
    }

    window.COMPONENTS.editUserChallengeApp = openDialog;

    return () => {
      window.COMPONENTS.editUserChallengeApp = undefined;
    };
  }, [openDialog]);

  const DialogComponent = useCallback(
    () => <UserCreatedChallengeDialog isOpen={isOpen} onClose={closeDialog} challengeId={challengeId} />,
    [isOpen, closeDialog, challengeId]
  );

  return {
    openDialog,
    closeDialog,
    isOpen,
    DialogComponent
  };
};
